import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { RendererContentState_content$key } from '../src/RendererContentState/__generated__/RendererContentState_content.graphql.ts';

export const RendererContentState: LoadableType<{
	contentId: string;
	isDraft: boolean;
	hasSeparator?: boolean;
	contentFragmentRef?: RendererContentState_content$key | null;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RendererContentStateRendererContentState" */ '../src/RendererContentState/RendererContentState.tsx'
			)
		).RendererContentState,
});
